import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf905be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VacancyListItem" }
const _hoisted_2 = { class: "VacancyListItem__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "title__category" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "VacancyListItem__container" }
const _hoisted_7 = { class: "container__info mt-2" }
const _hoisted_8 = { class: "info__experience" }
const _hoisted_9 = { class: "info__salary" }
const _hoisted_10 = { class: "info__region" }
const _hoisted_11 = { class: "VacancyListItem__footer" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-pointer mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `/vacancies/vacancy/${_ctx.item.id}`,
          class: "title__name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(" в "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.category_name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small", {
                        primary: _ctx.item.status_code === _ctx.VacancyStatusesT.CREATED,
                        green: _ctx.item.status_code === _ctx.VacancyStatusesT.PUBLISHED,
                        red: _ctx.item.status_code === _ctx.VacancyStatusesT.ARCHIVE,
                    }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.status_name), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, "Требуемый опыт: " + _toDisplayString(_ctx.item.experience_name), 1),
        _createElementVNode("p", _hoisted_9, "Зарплата: " + _toDisplayString(_ctx.item.salary_from) + " - " + _toDisplayString(_ctx.item.salary_to), 1),
        _createElementVNode("p", _hoisted_10, "Регион: " + _toDisplayString(_ctx.item.region_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", null, _toDisplayString(_ctx.item.feedbacks_count), 1)
        ])
      ])
    ])
  ]))
}